interface BorderLoaderAnimationProps {
  strokeWidth?: string;
  strokeColor?: string;
  bgColor?: string;
  width?: number;
  height?: number;
  children?: React.ReactChild;
  animationDurationInSec?: string;
}
export default function BorderLoaderAnimation(props: BorderLoaderAnimationProps) {
  const { animationDurationInSec = "300s", children } = props;
  return (
    <div
      className="borderLoader"
      style={{ "--loadCircleAnimationDuration": animationDurationInSec } as React.CSSProperties}>
      <div className="centerContent">{children}</div>
      <div id="circle-loader-wrap">
        <div className="left-wrap">
          <div className="loaderCircle"></div>
        </div>
        <div className="right-wrap">
          <div className="loaderCircle"></div>
        </div>
      </div>
    </div>
  );
}
